import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal, WritableSignal } from '@angular/core';

import { GraphProfile, GraphService } from '@webgate/angular-azure-core';
import { Observable, of, tap } from 'rxjs';

import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  graphService = inject(GraphService);
  userProfile: WritableSignal<GraphProfile> = signal({
    jobTitle: '',
    businessPhones: []
  });

  private http = inject(HttpClient);
  configService = inject(ConfigService);

  allUserProfiles = signal<GraphProfile[]>([]);

  constructor() {
    this.graphService.getProfile().subscribe((profile) => {
      this.userProfile.set(profile);
    });
  }

  getUser(id: string): Observable<GraphProfile | undefined> {
    if (this.allUserProfiles().some((user) => user.id === id)) {
      return of(this.allUserProfiles().find((user) => user.id === id));
    }
    return of(undefined);
  }

  loadAllUser(): Observable<GraphProfile[]> {
    if (this.allUserProfiles().length !== 0) {
      return of(this.allUserProfiles());
    }
    return this.http
      .get<GraphProfile[]>(`${this.configService.getConfiguration().apiHost}/api/users`)
      .pipe(tap((profiles) => this.allUserProfiles.set(profiles)));
  }

  getAllUsers(): GraphProfile[] {
    return this.allUserProfiles();
  }

  getByNameOrEmail(term: string): GraphProfile[] {
    const lowerTerm = term.toLowerCase();
    return this.allUserProfiles().filter((profile) => {
      if (profile.displayName && profile.displayName?.toLowerCase().includes(lowerTerm)) return true;
      if (profile.givenName && profile.givenName.toLowerCase().includes(lowerTerm)) return true;
      if (profile.surname && profile.surname.toLowerCase().includes(lowerTerm)) return true;
      if (profile.mail && profile.mail.toLowerCase().includes(lowerTerm)) return true;
      return false;
    });
  }
}
